export enum ValidationTypes {
    CARD_DETECTION = 'CARD',
    BARCODE_DETECTION = 'BARCODE',
    SHARPNESS_DETECTION = 'SHARPNESS',
    GLARE_DETECTION = 'GLARE',
    PORTRAIT_ORIENTATION_DETECTION = 'PORTRAIT',
    LANDSCAPE_ORIENTATION_DETECTION = 'LANDSCAPE',
    GOOD_RESOLUTION_DETECTION = 'RESOLUTION',
    LIVENESS_DETECTION = "LIVENESS",
    UNKNOWN = "UNKNOWN"
}